import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import amplifyconfig from './amplify_outputs.json';

// #region agent log - Hypothesis B,E: Detect browser and page load type
const browserInfo = {
  userAgent: navigator.userAgent,
  isChrome: navigator.userAgent.includes('Chrome') && !navigator.userAgent.includes('Edg'),
  isSafari: navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome'),
  isEdge: navigator.userAgent.includes('Edg'),
  pageLoadType: performance.navigation?.type || (performance.getEntriesByType('navigation')[0] as any)?.type,
  fromCache: (performance.getEntriesByType('navigation')[0] as any)?.transferSize === 0
};
console.log('🔍 [CHROME-DEBUG] Browser and page load info:', browserInfo);
// #endregion

// Debug the configuration
console.log('🔧 Amplify config loaded:', amplifyconfig);
console.log('🔧 GraphQL URL:', amplifyconfig.data?.url);
console.log('🔧 API Key:', amplifyconfig.data?.api_key?.substring(0, 10) + '...');
console.log('🔧 NODE_ENV:', process.env.NODE_ENV);

// Configure Amplify before any other imports
try {
  // #region agent log - Hypothesis A,C: Track storage state before config
  const storageBeforeConfig = {
    localStorageCount: localStorage.length,
    sessionStorageCount: sessionStorage.length,
    hasAmplifyKeys: Object.keys(localStorage).some(k => k.includes('amplify')),
    hasCognitoKeys: Object.keys(localStorage).some(k => k.includes('cognito') || k.includes('CognitoIdentity')),
    allKeys: [...Array(localStorage.length)].map((_, i) => localStorage.key(i))
  };
  console.log('🔍 [CHROME-DEBUG] Browser storage BEFORE Amplify.configure:', storageBeforeConfig);
  // #endregion
  
  console.log('🔧 DEBUG: amplify_outputs.json config', {
    hasAuth: !!amplifyconfig.auth,
    hasData: !!amplifyconfig.data,
    dataUrl: amplifyconfig.data?.url,
    defaultAuthMode: amplifyconfig.data?.default_authorization_type,
    apiKeyPrefix: amplifyconfig.data?.api_key?.substring(0, 15),
    hasIdentityPool: !!(amplifyconfig.auth as any)?.Cognito?.identityPoolId
  });
  
  // #region agent log - Hypothesis D: Track timing
  const configStartTime = performance.now();
  console.log('🔍 [CHROME-DEBUG] Amplify.configure() starting at:', configStartTime, 'ms');
  // #endregion
  
  Amplify.configure(amplifyconfig);
  
  // #region agent log - Hypothesis D: Track timing
  const configEndTime = performance.now();
  console.log('🔍 [CHROME-DEBUG] Amplify.configure() completed in:', (configEndTime - configStartTime).toFixed(2), 'ms');
  // #endregion
  
  // #region agent log - Hypothesis A,C: Track storage state after config
  const storageAfterConfig = {
    localStorageCount: localStorage.length,
    sessionStorageCount: sessionStorage.length,
    amplifyKeys: Object.keys(localStorage).filter(k => k.includes('amplify')),
    cognitoKeys: Object.keys(localStorage).filter(k => k.includes('cognito') || k.includes('CognitoIdentity')),
    storageChanged: localStorage.length !== storageBeforeConfig.localStorageCount
  };
  console.log('🔍 [CHROME-DEBUG] Browser storage AFTER Amplify.configure:', storageAfterConfig);
  // #endregion
  
  console.log('🔧 DEBUG: AFTER Amplify.configure - browser storage', {
    localStorageKeys: Object.keys(localStorage).filter(k => k.includes('amplify') || k.includes('cognito') || k.includes('CognitoIdentity')),
    sessionStorageKeys: Object.keys(sessionStorage).filter(k => k.includes('amplify') || k.includes('cognito'))
  });
  
  console.log('✅ Amplify configured successfully');
  console.log('🔐 Guest access is enabled by default in Amplify Gen 2');
} catch (error) {
  console.error('❌ Amplify configuration failed:', error);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
